import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Target, ArrowRight, TrendingUp } from "lucide-react";

const RISK_COLOR = {
  "düşük": "text-green-200",
  "orta": "text-amber-200",
  "yüksek": "text-orange-200",
  "çok yüksek": "text-red-200",
};

export default function TargetTrackingCard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/target/progress").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (data === null) {
    return (
      <div className="rounded-2xl border border-slate-200 bg-white p-5 animate-pulse">
        <div className="h-20" />
      </div>
    );
  }

  if (!data.target) {
    return (
      <Link to="/hedef" data-testid="target-empty-card"
        className="block rounded-2xl border-2 border-dashed border-slate-300 bg-white p-5 hover:border-[#FF6B6B] hover:bg-rose-50/30 transition group">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-2xl bg-rose-50 text-[#FF6B6B] flex items-center justify-center shrink-0">
            <Target className="w-6 h-6" />
          </div>
          <div className="flex-1">
            <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">Hedef Lise</div>
            <h2 className="font-heading text-lg font-bold text-slate-900">Hedef belirle</h2>
            <p className="text-xs text-slate-500 mt-0.5">Çalışma planın hedefe göre şekillensin</p>
          </div>
          <ArrowRight className="w-5 h-5 text-slate-400 group-hover:text-[#FF6B6B] group-hover:translate-x-1 transition" />
        </div>
      </Link>
    );
  }

  const t = data.target;
  const est = data.estimate;
  const gap = data.gap;

  return (
    <Link to="/hedef" data-testid="target-card"
      className="block rounded-2xl bg-gradient-to-br from-slate-800 to-slate-900 text-white p-5 hover:from-slate-700 hover:to-slate-800 transition group">
      <div className="flex items-start justify-between gap-2 mb-3">
        <div className="min-w-0">
          <div className="flex items-center gap-1.5 text-rose-200 text-[10px] uppercase tracking-wider font-semibold">
            <Target className="w-3 h-3" /> Hedef
          </div>
          <h2 className="font-heading text-lg font-bold truncate">{t.school_name}</h2>
          <div className="text-[10px] text-slate-300 mt-0.5">{t.school_type_label}</div>
        </div>
        <ArrowRight className="w-4 h-4 text-rose-200 group-hover:translate-x-1 transition shrink-0" />
      </div>

      <div className="grid grid-cols-3 gap-2">
        <div>
          <div className="text-[9px] text-slate-400 uppercase">Şu an</div>
          <div className="font-display text-lg font-bold">{est.estimated_score}</div>
        </div>
        <div>
          <div className="text-[9px] text-rose-200 uppercase">Hedef</div>
          <div className="font-display text-lg font-bold text-rose-300">{t.safe_score}</div>
        </div>
        <div>
          <div className="text-[9px] text-slate-400 uppercase">Fark</div>
          <div className="font-display text-lg font-bold">
            {gap?.gap_points > 0 ? `${gap.gap_points}` : "✓"}
          </div>
        </div>
      </div>

      {gap && (
        <div className={`flex items-center gap-1.5 text-xs mt-3 ${RISK_COLOR[gap.risk_level] || "text-slate-300"}`}>
          <TrendingUp className="w-3 h-3" /> {gap.label}
        </div>
      )}
    </Link>
  );
}
